import { AllowedAccess } from "react-permission-role";
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Roles, Permissions, WebStorageNames } from '../../utils/Constants';
import { storageService } from "../../services";


const AccessLevel = (props) => {
    const storedpermissions=storageService.getItem(WebStorageNames.permissions) || [];
    const role=storageService.getItem(WebStorageNames.Role);
    return (
      
        <AllowedAccess
            roles={[role]}
            permissions={props.permissions}
        >
            {props.children}
        </AllowedAccess>)
}

export default AccessLevel;
